import type { WidgetComponent } from '../functional-components/offsites-widget-components.d';
import {
  apcWidget,
  defaultWidget,
  mediaWidget,
  avevaWidget
} from '../functional-components/offsites-widget-components';
import { showBannerForPeriod, lowerCaseArrayInArrayOfObjects } from './helpers';
import { widgetStatistics } from '../offsites-widget-statistics';

export const numberOfLinks = 4;

export function mapWidgetData(
  widgetData: any,  //eslint-disable-line
  country: string,
  language: string,
  term: string,
  brand: string,
  tab: string,
  relatedProduct?: string
): any { //eslint-disable-line
    let widget: any = {}; //eslint-disable-line
    const widgets = retrieveConfigForLocale(widgetData, country, language);

    if (widgets) {
      const termToLowerCase = term?.toLowerCase();
      const widgetsValues = Object.values(widgets);
      const widgetsForTab = widgetsValues.filter(el => !el['tabs'] || el['tabs'].includes(tab));
      const widgetsWithLowerCaseKeywords = lowerCaseArrayInArrayOfObjects(widgetsForTab, 'keywords');

      const globalWidget = findWidget(widgetsWithLowerCaseKeywords, 'keywords', '*', brand);
      if (globalWidget) {
        widget = globalWidget;
      }

      if (relatedProduct) {
        const relatedProductWidget = findWidget(widgetsWithLowerCaseKeywords, 'relatedProduct', relatedProduct, brand);

        if (relatedProductWidget) {
          widget = relatedProductWidget;
        }
      }

      const filteredByKeyword = findWidget(widgetsWithLowerCaseKeywords, 'keywords', termToLowerCase, brand);
      if (filteredByKeyword) {
        widget = filteredByKeyword;
      }

      if (!filteredByKeyword) {
        const matchedWidget = matchWidget(widgetsWithLowerCaseKeywords, 'keywords', termToLowerCase, brand);
        if (matchedWidget) {
          widget = matchedWidget;
        }
      }
    }

    const isVisible = shouldBeVisible(widget);

    return isVisible ? widget : {};
}

export const findWidget = (
  object: Array<WidgetComponent>,
  field: string,
  term: string,
  brand: string
) => object.filter((element) => element[field]?.includes(term)).find((el) => el['brand'] == brand);

export const matchWidget = (
  object: Array<WidgetComponent>,
  field: string,
  term: string,
  brand: string
) => {
    return object.filter((element) =>
      element[field]?.find(
        (keyword:string)=> {
            return keyword.toLowerCase().startsWith(term?.toLowerCase()) ||
          term?.toLowerCase().startsWith(keyword.toLowerCase());
        }
      ))
      .find(
        (el) => el['brand'] == brand
      );
};

export const shouldBeVisible = (widget) => {
    let showBanner = true;

    if (widget.isPermanent === false) showBanner = showBannerForPeriod(widget.startDate, widget.endDate);

    return showBanner;
};

export function retrieveConfigForLocale(widgetData, country, language) {
    const langs = widgetData.language;
    if (!langs) {
      return {};
    }
    const countries = langs[language]?.country;
    if (!countries) {
      return {};
    }
    return countries[country] || {};
}

export const mapToCreation = (data, emitSearchStatisticsEvent, tabName, analiticsTabName, isDashboardView) => {
    const targetTabName = isDashboardView ? analiticsTabName : tabName;

    if (targetTabName) emitSearchStatisticsEvent(widgetStatistics.sendPresentationStatisticsEvent(targetTabName, data.widgetName, true, data.widgetType));

    switch (data.widgetType) {
    case 'apc':
      return apcWidget(data, emitSearchStatisticsEvent, tabName);
    case 'media':
      return mediaWidget(data, emitSearchStatisticsEvent, tabName);
    case 'aveva':
      return avevaWidget(data, emitSearchStatisticsEvent, tabName);
    default:
      return defaultWidget(data, emitSearchStatisticsEvent, tabName, isDashboardView);
    }
};
